<template>
    <!-- <pre>{{filteredData}}</pre> -->
    <div v-if="dtPost"
         class="DataTableWrapper DataTable--small"
         :class="'DataTableWrapper-' + dtPost.id + ' ' + ( data.database_columns_data.length ? 'DataTable--hoverable DataTable--striped' : '' )"
         :id="`data-datable-wrapper-${dtPost.id}`
        ">
        <table class="DataTable" :id="`data-table-${data.data_view.id}`">
            <thead>
            <tr class="DataTable__row DataTable__row_head">
                <template v-for="(column, index) in database_columns" :key="column.column_name">
                    <!-- <pre>{{ column }}</pre> -->
                    <th class="DataTable__cell" :class="['cell-type-' + column.format]" :dataType="column.format"
                        :data-sort="sortEnabled(column) ? column.column_name : null"
                        :data-order="sortEnabled(column) ? sortOrder(column) : ''"
                        @click="sort(column, index, column.sort.dir)"
                    >
                        <div class="DataTable_cell_head">
                            <span>{{ column.column_title }}</span>
                            <svg viewBox="0 0 24 24" class="sort-icon-default svg-icon" aria-hidden="true"><use xlink:href="#bliss-icon-expand"></use></svg>
                            <svg viewBox="0 0 24 24" class="sort-icon-desc svg-icon" aria-hidden="true"><use xlink:href="#bliss-icon-chevron-up-large"></use></svg>
                            <svg viewBox="0 0 24 24" class="sort-icon-asc svg-icon" aria-hidden="true"><use xlink:href="#bliss-icon-chevron-down-large"></use></svg>
                        </div>
                    </th>
                </template>
            </tr>
            </thead>
            <!-- <tr v-for="item in filteredData" :key="item.id">
                <td>xxx</td>
            </tr> -->
            <template v-if="displayedItems.length">

                <tr
                    v-for="row in displayedItems" :key="row.id"
                    class="DataTable__row"
                    :data-clickable="row.clickable_element ? 'true' : 'false'"
                    :data-clickable-url="row.clickable_element.url ?? null"
                >
                    <template v-for="cell in row" :key="cell.column_name_id">

                        <td v-if="cell.format" class="DataTable__cell" :class="`cell-type-${cell.format}`">

                            <template v-if="'status_actions' == cell.format && cell.value">
                                <template v-for="action_btn in cell.value">
                                    <a
                                        :href="action_btn.url"
                                        :data-redirect="action_btn.result_event ? action_btn.result_event : null"
                                        class="Btn Btn--primary Btn--small"
                                        :class="action_btn.headless_module ? 'headless-module' : ''"
                                        @click="actionClickHandler($event, action_btn)"
                                        ><span v-show="action_btn.button_type == 'icon-button'" :class="action_btn.button_icon "></span>{{ action_btn.button_type == 'text-button' ? action_btn.button_text : '' }}</a>

                                </template>
                            </template>

                            <template v-else-if="'status-badge' == cell.format">
                                <div v-html="cell.value"></div>
                            </template>

                            <!-- {% elseif 'progress' == cell.format and not downgraded %}

                                {% include 'common/_progress-bar.twig' with { cell_content: cell.value } %} -->

                            <template v-else-if="('color-dot' == cell.format && !data.downgraded) || 'date' == cell.format || ('download' == cell.format && cell.value)">
                                <div v-html="cell.value"></div>
                            </template>

                            <!-- {% elseif 'hyperlink' == cell.format and cell.value %}
                                {{ fn('bryter_get_hyperlink_button', cell.original_value, true ) }}
                            
                             -->
                            <!-- {% elseif '' == cell.format and cell.original_value %} -->

                            <template v-else-if="'first-8-letters' == cell.format && cell.original_value">
                                {{ cell.value.substring(0, 8) }}
                            </template>


                            <template v-else-if="'long-text-in-two-rows' == cell.format">
                                <div class="text-two-rows" v-html="cell.value"></div>
                            </template>

                            <template v-else-if="'long-text' == cell.format">
                                <div v-if="cell.value" class="long-text" v-html="cell.value"></div>
                            </template>

                            <template v-else-if="'text' == cell.format">
                                <div v-if="cell.value" class="text" v-html="cell.value"></div>
                            </template>

                            <template v-else-if="'width-placeholder' == cell.format">
                                {{ '<!-- width placeholder -->' }}
                            </template>


                            <template v-else>
                                <!-- v else -->
                                <!-- {% if '+' not in column.column_name %}
                                    {{ row[column.column_name] ?: ( row[column.column_name] is defined  ? 0 : '' ) }}
                                {% else %}
                                    {{ fn('bryter_plugin_multiple_strings_in_td', column.column_name, column.column_separator, row) }}
                                {% endif %} -->
                                <div v-html="cell.value"></div>

                            </template>

                        </td>
                    </template>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td
                        :colspan="data.database_columns.length">
                        <div class="DataTable DataTable--flexible DataTable--empty display-flex flex-direction-column justify-content-center">
                            <div class="pl-8 flex-grow-1 display-flex align-items-center">
                                <div v-if="feTheme">
                                    <h2 class="title-1 margin-bottom-2">{{ feTheme.no_data_title ?? 'No data available' }}</h2>
                                    <span class="text-gray-dark">{{ feTheme.no_data_text ?? 'There is currently no data to be shown here.' }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
        </table>



    </div>
    <div class="mt-4 text-center pagination-wrap" v-show="pagination.enabled && pages.length">
            <nav class="pagination" aria-label="Pagination">
                <ul class="pagination-list padding-0">
                    <li>
                        <button
                            class="bliss-button bliss-button--theme-default bliss-button--secondary"
                            :disabled="(currentPage <= 1 ) ? true : false"
                            @click="changePage(--currentPage)"
                            ><span class="bliss-button__text">{{ feTheme.lang__pagination_previous ?? 'Previous' }}</span></button>
                    </li>
                    <template
                        v-for="(page, index) in summaryPages"
                        :key="page">
                        <li v-if="!(index == 0 || ( page - summaryPages[index-1] == 1 ))"><div>...</div></li>
                        <li>
                            <button
                                class="bliss-button bliss-button--theme-default"
                                :class="(page == currentPage) ? 'bliss-button--primary' : 'bliss-button--secondary'"
                                @click="changePage(page)"
                                ><span class="bliss-button__text">{{ page }}</span></button>
                            
                        </li>

                    </template>
                    
                    <li>
                        <button
                            class="bliss-button bliss-button--theme-default bliss-button--secondary"
                            :disabled="(currentPage >= pages.length ) ? true : false"
                            @click="changePage(++currentPage)"
                            ><span class="bliss-button__text">{{ feTheme.lang__pagination_next ?? 'Next' }}</span></button>
                    </li>
                </ul>
            </nav>
        </div>  
</template>

<script lang="ts">

// import { BlissButton } from '@bliss/button';
import { headlessModuleSessionVerify } from '../../lib/common'
import { defineComponent } from 'vue'

// export default {
export default defineComponent({
    props: {
        feTheme: {
            default: {},
            type: Object
        },
        dtPost: Object,
        templateData: Object,
        keyword: String
    },
    components: {
        // BlissButton,
    },
    data() {
        return {
            data: this.templateData,
            sorting: {
                sortType: '',
                columnName: '',
                sortOrder: 'asc'
            },

            isFromSecondayComponent: this.detailsViewId,
            currentPage: 1
		}
	},

    created() {
        // this.data = this.templateData
        this.data.database_columns = this.data.database_columns.map( item => {
            item.sort = {
                dir: 0
            }
            return item
        })

        this.emitter.on('datatable-filter-applied', (evt) => {
            this.currentPage = 1
        })
    },

    updated() {
        // this.data = this.templateData
        // let sorting = this.sorting
        // this.data.database_columns = this.data.database_columns.map( item => {
        //         item.sort = {
        //             dir: sorting.columnName == item.column_name ? (sorting.sortOrder == 'asc' ? 1 : -1) : 0
        //         }
        //         return item
        //     })

    },

    emits: ['sort'],

    inject: {
        detailsViewId: {
            from: 'detailsViewId', // this is optional if using the same key for injection
            default: false
        },
        tabId: {
            from: 'tabId',
            default: null
        },
        linksTarget: {
            from: 'dataLinksTarget',
            default: null
        }
    },

	computed: {
        pagination() {
            return this.templateData.pagination
        },
        filteredData() {
            // console.log(this.templateData.database_columns_data)

            // interface Row {
            //     show: string,
            //     value: Array<any>,
            // }

            let keyword = this.keyword
            this.data.database_columns_data.map( row => {
                if ( keyword ) {
                    row.show = false
                    let rowValues: Array<any>
                    rowValues = Object.entries(row)
                    for (const [key, valueData] of rowValues ) {
                        // let valueData = row[key]
                        const value = valueData.value
                        if ( value ) {
                            let searchColumns = JSON.parse(JSON.stringify(this.data.search))
                            if (value.indexOf(this.keyword) !== -1 &&
                                searchColumns.length && searchColumns.includes(`${key.substring(0, key.indexOf(':'))}`)
                            ) {
                                row.show = true;
                            }
                        }
                    }
                } else {
                    row.show = true
                }
                return row
            })

            return this.data.database_columns_data.filter( item => item.show )
        },
        database_columns() {
            return this.data.database_columns
        },

        pageCount() {
            return this.pagination.enabled ? Math.ceil( this.filteredData.length / this.pagination.itemsPerPage ) : 1
        },
        
        pages() {
            const allpages = Array.from({ 
                                length: this.pageCount 
                                }, 
                                (_, i) => i + 1
                            )

            return allpages
        },

        summaryPages() {
            // if (this.pages.length >= 8 ) {
                const summarypages = []
                // let half = Math.floor(this.pages.length / 2)
                for ( let i=0; i<this.pages.length; i++) {
                    if ( i <= 1 || i < this.currentPage + 1 && i >= this.currentPage-2 || i>=this.pages.length - 2 ) {
                        summarypages.push( this.pages[i] )
                    }
                }
                return summarypages
            // } e
        },

        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.pagination.itemsPerPage;
            const endIndex = startIndex + this.pagination.itemsPerPage;
            // console.log('pagination indexes::', startIndex, endIndex)
            return this.pagination.enabled ? this.filteredData.slice(startIndex, endIndex) : this.filteredData;
        },
    },

    methods: {
        sortEnabled(column) {
            return this.data.data_view.ss_enabled && ! ['status_actions'].includes( column.format )
        },
        sortOrder(column) {
            // return this.data.hs_enabled && this.data.hs_sorting_column == column.column_name ? this.data.hs_sorting_order : null
            // console.log(column.sort.dir)
            return column.sort.dir == 1 ? 'asc' : column.sort.dir == -1 ? 'desc' : ''
        },
        sort(column, index, dir) {
            column.sort.dir = (dir != 0) ? ( dir == 1 ? -1 : 1 ) : 0;

            this.sorting = {
                columnName: column.column_name,
                sortOrder: column.sort.dir == 1 ? 'asc' : 'desc',
                sortType: column.format
            }
            // console.log(dir, column.sort.dir)
            // console.log(column, index, dir)
            this.$emit('sort', {
                column,
                sorting: this.sorting
            })
            
            // this.data.database_columns_data.sort( (a, b) => {
            //     console.log(a[column_pos_name], b[column_pos_name])
            //     if (a[column_pos_name].value === b[column_pos_name].value) {
            //         return 0;
            //     }
            //     else {
            //         return (a[column_pos_name].value < b[column_pos_name].value) ? -1 : 1;
            //     }
            // })
        },

        actionClickHandler(e, action_btn) { 
            
            const a = e.currentTarget,
                href = a.getAttribute('href')

            

            if ( action_btn.headless_module ) {

                e.preventDefault()

                a.setAttribute('disabled', 'disabled')    

                const data = {
                        action: 'headlessModule',
                        params: href,
                        env: window.BRYTER.envId,
                    }

                fetch( window.BRYTER.ajaxUrl, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify(data)
                  // body: data
                })
                // .then((response) => response.json())
                .then((responseJson) => {
                    // this.myFunction(responseJson);
                    a.removeAttribute('disabled');
                    headlessModuleSessionVerify();
                })



            //     const params = button.attr('href');
            //     button.attr('disabled', 'disabled');
            //     $.ajax({
            //         url: BRYTER.ajaxUrl,
            //         data: {
            //             action: 'headlessModule',
            //             params: params,
            //             env: BRYTER.envId,
            //         },

            //         success: function( result ) {
            //             button.removeAttr('disabled');
            //             that.headlessModuleSessionVerify();
            //         }
            //     })
            // });

            } else {

                if ( ! this.isFromSecondayComponent ) {
                    return;
                }

                this.emitter.emit('topActionButtonClick', {
                                                        'button': a,
                                                        'tabId': this.tabId,
                                                        'linksTarget': this.linksTarget,
                                                        'href': href,
                                                        'event': e,
                                                        'redirect': a.getAttribute('data-redirect')
                                                    })
            }

            return false;
        },

        changePage(pageNumber) {
            this.currentPage = pageNumber;
        },
    }
})
</script>

<style scoped>

</style>